import React from 'react';
import JavascriptFunctionsDefinitions from './JavascriptFunctionsDefinitions.jsx';
import JavascriptFunctionsArrows from './JavascriptFunctionsArrows.jsx';
import JavascriptFunctionsParameters from './JavascriptFunctionsParameters.jsx';
import JavascriptFunctionsInvocation from './JavascriptFunctionsInvocation.jsx';
import JavascriptFunctionsThis from './JavascriptFunctionsThis.jsx';
import JavascriptFunctionsCall from './JavascriptFunctionsCall.jsx';
import JavascriptFunctionsApply from './JavascriptFunctionsApply.jsx';
import JavascriptFunctionsBind from './JavascriptFunctionsBind.jsx';
import JavascriptFunctionsClosures from './JavascriptFunctionsClosures.jsx';

export default function JsFunctions() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Functions</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/functions/definitions' className='underline'>Function Definitions</a></li>
<li><a href='/javascript/functions/arrows' className='underline'>Function Arrows</a></li>
<li><a href='/javascript/functions/parameters' className='underline'>Function Parameters</a></li>
<li><a href='/javascript/functions/invocation' className='underline'>Function Invocation</a></li>
<li><a href='/javascript/functions/this' className='underline'>Function this</a></li>
<li><a href='/javascript/functions/call' className='underline'>Function Call</a></li>
<li><a href='/javascript/functions/apply' className='underline'>Function Apply</a></li>
<li><a href='/javascript/functions/bind' className='underline'>Function Bind</a></li>
<li><a href='/javascript/functions/closures' className='underline'>Function Closures</a></li>
      </ul>
    </div>
  );
}
